var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCashcheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-cashcheck",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.748,
    height: 35.053,
    viewBox: "0 0 44.748 35.053",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2411",
    "data-name": "Path 2411",
    d: "M269.221,279.976a2.975,2.975,0,0,0-1.977.926c-.41.351-.677.566-1.006.566a.864.864,0,0,1-.671-.224,2.3,2.3,0,0,0-1.566-.522v1.492a.864.864,0,0,1,.671.224,2.3,2.3,0,0,0,1.566.522,2.975,2.975,0,0,0,1.977-.926c.41-.351.677-.566,1.006-.566a.862.862,0,0,1,.671.224,2.291,2.291,0,0,0,1.566.522v-1.492a.862.862,0,0,1-.671-.224A2.291,2.291,0,0,0,269.221,279.976Zm0,0",
    transform: "translate(-239.389 -253.873)",
    fill: "#0176c0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2412",
    "data-name": "Path 2412",
    d: "M98.237,170.237h1.492a.746.746,0,0,1,.746.746h1.492a2.238,2.238,0,0,0-2.237-2.237V168H98.237v.746a2.237,2.237,0,1,0,0,4.475h1.492a.746.746,0,0,1,0,1.492H98.237a.746.746,0,0,1-.746-.746H96a2.238,2.238,0,0,0,2.237,2.237v.746h1.492V176.2a2.237,2.237,0,1,0,0-4.475H98.237a.746.746,0,1,1,0-1.492Zm0,0",
    transform: "translate(-87.05 -152.338)",
    fill: "#0176c0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2413",
    "data-name": "Path 2413",
    d: "M192,200h13.424v1.492H192Zm0,0",
    transform: "translate(-174.101 -181.355)",
    fill: "#0176c0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2414",
    "data-name": "Path 2414",
    d: "M192,232h1.492v1.492H192Zm0,0",
    transform: "translate(-174.101 -210.372)",
    fill: "#0176c0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2415",
    "data-name": "Path 2415",
    d: "M224,232h1.492v1.492H224Zm0,0",
    transform: "translate(-203.118 -210.372)",
    fill: "#0176c0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2416",
    "data-name": "Path 2416",
    d: "M256,232h1.492v1.492H256Zm0,0",
    transform: "translate(-232.134 -210.372)",
    fill: "#0176c0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2417",
    "data-name": "Path 2417",
    d: "M288,232h1.492v1.492H288Zm0,0",
    transform: "translate(-261.151 -210.372)",
    fill: "#0176c0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2418",
    "data-name": "Path 2418",
    d: "M320,232h1.492v1.492H320Zm0,0",
    transform: "translate(-290.168 -210.372)",
    fill: "#0176c0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2419",
    "data-name": "Path 2419",
    d: "M48,168h1.492v1.492H48Zm0,0",
    transform: "translate(-43.525 -152.338)",
    fill: "#0176c0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2420",
    "data-name": "Path 2420",
    d: "M48,200h1.492v1.492H48Zm0,0",
    transform: "translate(-43.525 -181.355)",
    fill: "#0176c0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2421",
    "data-name": "Path 2421",
    d: "M48,232h1.492v1.492H48Zm0,0",
    transform: "translate(-43.525 -210.372)",
    fill: "#0176c0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2422",
    "data-name": "Path 2422",
    d: "M48,264h1.492v1.492H48Zm0,0",
    transform: "translate(-43.525 -239.389)",
    fill: "#0176c0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2423",
    "data-name": "Path 2423",
    d: "M48,296h1.492v1.492H48Zm0,0",
    transform: "translate(-43.525 -268.405)",
    fill: "#0176c0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2424",
    "data-name": "Path 2424",
    d: "M44,0H12.679a.746.746,0,0,0-.746.746V12.679H.746A.746.746,0,0,0,0,13.424V34.307a.746.746,0,0,0,.746.746h35.8a.746.746,0,0,0,.746-.746V23.866H44a.746.746,0,0,0,.746-.746V.746A.746.746,0,0,0,44,0ZM24.611,8.95a3.729,3.729,0,1,1,3.729,3.729A3.729,3.729,0,0,1,24.611,8.95Zm8.95,0a5.221,5.221,0,1,0-8.867,3.729h-7.03a6.643,6.643,0,0,0-4.24-2.2V7.414a6.72,6.72,0,0,0,5.922-5.922H37.334a6.72,6.72,0,0,0,5.922,5.922v3.071a6.72,6.72,0,0,0-5.922,5.922H37.29V13.424a.746.746,0,0,0-.746-.746H31.987A5.2,5.2,0,0,0,33.561,8.95Zm9.7,7.458H38.835a5.233,5.233,0,0,1,4.422-4.422ZM37.29,17.9h5.966v1.492H37.29ZM43.257,1.492V5.914a5.233,5.233,0,0,1-4.422-4.422Zm-29.832,0h4.422a5.233,5.233,0,0,1-4.422,4.422Zm0,10.493a5.164,5.164,0,0,1,1.939.694H13.424ZM1.492,14.17H35.8V30.578H1.492ZM35.8,33.561H1.492V32.07H35.8Zm7.458-11.187H37.29V20.882h5.966Zm0,0",
    fill: "#0176c0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCashcheck);
export default __webpack_public_path__ + "static/media/ic-cashcheck.f5b48b4c.svg";
export { ForwardRef as ReactComponent };